export default "__VITE_ASSET__Dzdtnwqk__"